import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { RedocStandalone } from 'redoc';

class App extends Component {
    render() {
        return (
            <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <h1 className="App-title">Proofn Documentation</h1>
                </header>
                <RedocStandalone specUrl={process.env.REACT_APP_SPEC_URL} />
            </div>
        );
    }
}

export default App;
